"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M14 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0M8 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0m10 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-8 5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-4-5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m6-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
}), 'NetworkFilled');
//# sourceMappingURL=index.js.map